import { Route, useParams } from 'react-router-dom';
import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Box, Text, Image, Flex } from 'rebass';
import store from 'store';

import StoryMutePopup from 'stories/mute/popup';
import useHandleScrollSubject from 'stories/hooks/handle-scroll-subject';
import NewMeetingPopup from 'stories/chats/popup';
import { TagContextProvider } from '../collections/detail/tag-context';
import { useEntity } from '../entities/hooks';
import StoryTagsModal from './tags/modal';
import Loading from '../app/loading';
import StoryDelete from './delete/modal';
import StoryDetailHeaderNav from './story-detail-header/story-detail-header-nav';
import StoryJournalModal from './journal';
import StoryOptions from './options';
import StorySharedModal from '../story-shares/shared-story-modal';
import StoryShareOptions from './options/share-options';
import { useMarkStoryNotificationsRead } from '../notifications/notification/helper';
import StoryDetailPageList from './list';
import StoryDetailNotify from './notify';
import useLocation from 'app/hooks/location';
import { LetsBeginFooterComponent } from './new/global/lets-begin';
import { useFirstTimeUserFlowVisible } from './hooks/index';
import Modal from 'app/modal/v3/index';
import ftuiReviewStory from './assets/BabyPandaRocking.png';
import { useDispatch } from 'react-redux';
import { togglefirstTimeUserFlowVisible, toggleFtuiFinalStepVisible } from './actions';
import { useBookPages, BOOK_PAGES_STATES } from './book-pages-context';
import PageSlider from '../collections/book-creation/components/PageSlider';
import { useWindowSize } from 'react-use';
import BufferingOverlay from 'app/modal/BufferingOverlay';

let alreadySeen = false

const BookPagesSection = ({ id }) => {
  const { width } = useWindowSize();
  const {
    state,
    pages,
    isLoading,
    currentPage,
    setCurrentPage,
    selectedPageIndex,
    setSelectedPageIndex,
    totalPagesData,
    setTotalPagesData,
  } = useBookPages();

  return (
    <BufferingOverlay
      isBuffering={state !== BOOK_PAGES_STATES.FINISHED}
      showLoadingText
      loadingText={state === BOOK_PAGES_STATES.WAITING_FOR_MEDIA ? "Waiting for media to be ready" : "Creating your book pages"}
      sx={{ height: '100vh' }}
      color='#fff'
      bg='rgba(0,0,0,0.6)'
      showHeaderText
      headingText="Creating your preview"
    >
      <PageSlider
        boxWidth={width}
        firstBookId={id}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        selectedPageIndex={selectedPageIndex}
        setSelectedPageIndex={setSelectedPageIndex}
        totalPagesData={totalPagesData.length ? totalPagesData : pages}
        setTotalPagesData={setTotalPagesData}
        loading={state !== BOOK_PAGES_STATES.FINISHED}
        isReadOnly
      />
    </BufferingOverlay>
  );
  // }

  // return null;
};

const StoryDetail = ({ refreshBookPages }) => {
  const { id } = useParams();
  useHandleScrollSubject();
  const { pathname } = useLocation();
  // const { error } = useStoryPagesSWR(id, { page: 1, per: 0 });

  const dispatch = useDispatch()
  const isFirstTimeUser = useFirstTimeUserFlowVisible()
  const [firstTimeUserModal, setFirstTimeUserModal] = useState(false)
  const isFromTellAStory = pathname?.includes('tell_a_story')
  const ftui_watched = store.get('first_story_ftui_watched');

  useEffect(() => {
    setFirstTimeUserModal(isFirstTimeUser || !ftui_watched)

  }, [isFirstTimeUser, ftui_watched])

  useEffect(() => () => {
    if (!store.get('ftui_watched'));
    dispatch(toggleFtuiFinalStepVisible(true))
  }, [])

  // Kicks off (or restarts) book-pages polling for this story. Without this, the
  // fetch only ever ran from the Edit/Done toggle's click handler, so landing here
  // directly — a hard refresh, or a link straight to a story — left BookPagesSection
  // stuck on "Creating your preview" forever (state never left its initial null).
  useEffect(() => {
    if (refreshBookPages) refreshBookPages(id);
  }, [id]);

  const { entity, isPresent } = useEntity({ id, type: 'stories' });

  useMarkStoryNotificationsRead(id);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // if (!isPresent && error) return <StoryDetailError />;
  if (!isPresent) return <Loading />;

  return (
    <TagContextProvider>
      {(firstTimeUserModal && !alreadySeen) && <Modal
        close={{
          onClose: () => {
            alreadySeen = true
            dispatch(togglefirstTimeUserFlowVisible(false));
            store.set('first_story_ftui_watched', true)
            setFirstTimeUserModal(false)
            // Advances to the final "you're making progress" step, rendered by
            // StoryDetailHeaderNav further down this same page.
            // dispatch(toggleFtuiFinalStepVisible(true));
          }
        }}
        maxWidth={620}
        closeOnOutsideClick={false}
        isScrollActive={false}
        aboveTooltip
        shadeProps={{ pt: [0, 4] }}
      >
        <Flex m="auto" mb="50px" flexDirection="column" justifyContent="center" alignItems="center" maxWidth={400}>
          <Image
            maxWidth={[200, 234]}
            src={ftuiReviewStory}
          />
          <Text fontFamily="Bitter" fontWeight="normal"
            textAlign="center"
            sx={{
              color: '#000',
              fontFamily: 'Bitter',
              fontSize: ['24px', '30px'],
              fontWeight: '500',
              lineHeight: '165%',
            }}
          >
            Here’s a First Look at<br />
            Your Story ✨
          </Text>
          <Text
            px={2}
            color="#64748B"
            fontFamily="Poppins"
            fontSize="16px"
            fontStyle="normal"
            fontWeight={400}
            lineHeight="150%"
            letterSpacing="-0.096px"
            textAlign='left'
            mb="30px"
          >
            <br />
            This is a preview to show how your memories can come together in your baby book.
            <br />
            <br />
            You’ll be able to edit and refine it later when you build your full book— this is just the beginning.
            {/* {!isFromTellAStory && <>
            <br />
            <br />
            Edit the story anytime from “All Stories” or in your “Chapters”
          </>} */}
          </Text>
          <LetsBeginFooterComponent
            sx={{ justifyContent: 'center', }}
            onStepUp={() => {
              alreadySeen = true
              store.set('first_story_ftui_watched', true)
              setFirstTimeUserModal(false)
              dispatch(togglefirstTimeUserFlowVisible(false));
            }}
            nextButtonText="Great!"
          />
        </Flex>
      </Modal>}
      <Box sx={{ zIndex: 1, position: 'relative' }} mb={['100px', 0]}>
        {/* {isFromTellAStory && <Box
          mb={3}
          sx={{
            display: ['flex', 'flex', 'none'],
            zIndex: 99999,
          }}
          width="100%" p={2} bg="#64748B" justifyContent={'space-between'} alignItems="center" >
          <Image src={whitebfyLogo} width={40} />
          <Text
            m="auto" fontFamily="Poppins" color="#FFFFFF" fontSize="22px" fontWeight={500} lineheight="20px">
            Reviewing Story</Text>
        </Box>} */}
        <StoryDetailHeaderNav id={id} refreshBookPages={refreshBookPages} footerSx={{
          display: ['block', 'block', 'block'],
          position: 'fixed',
          bottom: 0,
          width: '100vw',
          zIndex: 5
        }} isFirstTimeUser={isFirstTimeUser} setFirstTimeUserModal={setFirstTimeUserModal} />
        {/* <StoryDetailHeader story={entity} /> */}
        <Route
          exact
          path="/story/:id/delete"
          render={routeProps => <StoryDelete storyId={routeProps.match.params.id} />}
        />
        <Route exact path="/story/:id/shared" component={StorySharedModal} />
        <Route exact path="/story/:id/collection" component={StoryJournalModal} />
        <Route
          exact
          path="/story/:id/tags"
          render={routeProps => {
            const {
              match: { params },
              history,
            } = routeProps;
            return (
              <StoryTagsModal
                storyId={params.id}
                onBack={() => history.replace(`/story/${params.id}`)}
                {...routeProps}
              />
            );
          }}
        />
        <Route
          exact
          path="/story/:id/shares"
          render={routeProps => {
            const {
              match: { params },
              history,
            } = routeProps;
            return (
              <StoryShareOptions
                storyId={params.id}
                onClose={() => history.replace(`/story/${id}`)}
                {...routeProps}
              />
            );
          }}
        />
        <Route
          exact
          path="/story/:id/options"
          render={routeProps => {
            const {
              match: { params },
              history,
            } = routeProps;
            return (
              <StoryOptions
                storyId={params.id}
                onClose={() => history.replace(`/story/${id}`)}
                {...routeProps}
              />
            );
          }}
        />
        <Route
          exact
          path="/story/:id/mute"
          render={routeProps => {
            const {
              match: { params },
              history,
            } = routeProps;
            return (
              <StoryMutePopup
                storyId={params.id}
                onClose={() => history.replace(`/story/${id}`)}
                {...routeProps}
              />
            );
          }}
        />
        <Route path="/story/:id/notify" component={StoryDetailNotify} />
        <Route path="/story/:id/new-chat" component={NewMeetingPopup} />
        {/* <Box mb={['60px', 0]}>
          <StoryDetailPageList />
        </Box> */}
        <BookPagesSection id={id} />
        <StoryDetailHeaderNav id={id} refreshBookPages={refreshBookPages}
          isFirstTimeUser={isFirstTimeUser}
          setFirstTimeUserModal={setFirstTimeUserModal}
          footerSx={{
            display: ['block', 'block', 'none'],
            position: 'fixed',
            bottom: 0,
            width: '100vw',
            zIndex: 1
          }} />

      </Box>
    </TagContextProvider>
  );
};

export default StoryDetail;
